<template>
  <div class="account-flow">
    <div class="zz-page acc-record-page">
      <div class="page-content-new flex-box-div">
        <!-- 顶部标题 -->
        <otherHeaderTop
          headerTitle="账号记录"
          :showBack="true"
          @back="back"
          :showBalanceOne="false"
          :showBalanceTwo="false"
        ></otherHeaderTop>
        <div class="acc-record-page-content">
          <div class="type-tab-wrap" style="font-size: 26rpx">
            <div
              @click="changeTab(0)"
              :class="[curTab == 0 ? 'sel' : '']"
              class="type-tab-item"
            >
              <span>金币记录</span>
            </div>
            <div
              @click="changeTab(1)"
              :class="[curTab == 1 ? 'sel' : '']"
              class="type-tab-item"
            >
              <span>钻石记录</span>
            </div>
            <div
              @click="changeTab(2)"
              :class="[curTab == 2 ? 'sel' : '']"
              class="type-tab-item"
            >
              <span>充值记录</span>
            </div>
            <div
              @click="changeTab(3)"
              :class="[curTab == 3 ? 'sel' : '']"
              class="type-tab-item"
            >
              <span>提取记录</span>
            </div>
          </div>
          <div class="acc-record-content-wrap">
            <div class="filter-box-wrap"></div>
            <div class="record-content-inner">
              <div
                v-if="curTab == 0 || curTab == 1"
                class="balance-record-header header"
              >
                <div class="tran-time item">日期</div>
                <div class="tran-type item">类型</div>
                <div class="change-price item">收支</div>
                <div class="balance-price item">状态</div>
              </div>
              <!-- <div v-if="curTab == 1" class="balance-record-header header">
                <div class="tran-time item">日期</div>
                <div class="tran-type item">类型</div>
                <div class="change-price item">收支</div>
                <div class="balance-price item">状态</div>
              </div> -->
              <div v-if="curTab == 2" class="balance-record-header header">
                <div class="tran-time item w80">支付金额</div>
                <div class="tran-type item w80">支付渠道</div>
                <div class="change-price item w120">支付时间</div>
                <div class="balance-price item">支付单号</div>
              </div>
              <div v-if="curTab == 3" class="take-record-header header">
                <div class="take-time">饰品</div>
                <div class="prod-info">饰品名称</div>
                <div class="buy-back-price">提货价</div>
              </div>

              <!-- <div
                class="scroll-content-box"
                
              > -->
              <div role="feed" class="van-list">
                <template v-if="curTab == 0 || curTab == 1">
                  <!-- 触底加载 -->
                  <div class="scroll-content-box" @scroll="revenueListScroll">
                    <div
                      class="content-item"
                      v-for="(item, index) in RevenueList"
                      :key="index"
                    >
                      <div class="tran-time">
                        {{ item.createTime }}
                      </div>
                      <div class="tran-type">{{ item.remark }}</div>
                      <div class="change-price">{{ item.amount }}</div>
                      <div class="balance-price">
                        <div v-if="item.amount < 0" style="color: #10d7ff">
                          消费
                        </div>
                        <div v-else style="color: green">收入</div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="curTab == 2">
                  <div class="scroll-content-box" @scroll="rechargeScroll">
                    <div
                      class="content-item"
                      v-for="(item, index) in Recharge"
                      :key="index"
                    >
                      <div class="tran-time w80">
                        {{ item.goodsPrice }}
                      </div>
                      <div class="tran-type w80">
                        <div v-if="item.type == '2'">卡密</div>
                        <div v-if="item.type == '3'">支付宝</div>
                        <div v-if="item.type == '1'">支付宝</div>
                        <div v-if="item.type == '4'">微信</div>
                        <div v-if="item.type == '5'">微信</div>
                        <div v-if="item.type == '6'">支付宝</div>
                      </div>
                      <div class="change-price w120">{{ item.createTime }}</div>
                      <div class="balance-price">
                        <span @click="showD(item.orderId)">点击查看</span>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="curTab == 3">
                  <div
                    class="scroll-content-box"
                    @scroll="deliveryRecordsScroll"
                  >
                    <div
                      class="take-record-item"
                      v-for="(item, index) in deliveryRecordsList"
                      :key="index"
                    >
                      <div class="take-time">
                        <img :src="$getFullPath(item.ornamentImg)" alt />
                      </div>
                      <div class="prod-info">
                        <div class="info-box">
                          <div
                            class="prod-name"
                            style="
                              overflow: hidden;
                              max-height: 7 * 4.2px;
                              line-height: 4 * 4.2px;
                            "
                          >
                            {{ item.ornamentName }}
                          </div>
                        </div>
                      </div>
                      <div class="buy-back-price">
                        {{ item.ornamentsPrice }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-if="
                  ((curTab == 0 || curTab == 1) && RevenueList.length == 0) ||
                  (curTab == 2 && Recharge.length == 0) ||
                  (curTab == 3 && deliveryRecordsList.length == 0)
                "
              >
                <div class="no-data">
                  <div class="empty-box-new"></div>
                  <div class="tip-text">暂无数据</div>
                </div>
              </div>
              <!-- </div> -->
            </div>
            <!-- 提取二级分类 -->
            <div class="type-tab-wrap" v-if="curTab == 3">
              <div class="top-box">
                <div class="left">
                  <div
                    v-for="item in extractList"
                    :key="item"
                    @click="handlecategory(item.type)"
                    :class="[item.type == category ? 'sel' : '']"
                    class="roll-type-item"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付单号 -->
    <modalOrderId
      :showModal="showOrderId"
      :orderId="orderId"
      @close="showOrderId = false"
      @confirm="showOrderId = false"
    >
    </modalOrderId>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import modalOrderId from "@/components/common/modalOrderId.vue";
import {
  getUserLogList,
  userdecompseList,
  deliveryRecords,
  rechargeRecords,
} from "@/api/index";
export default {
  components: {
    otherHeaderTop,
    modalOrderId,
  },
  data() {
    return {
      // key: value
      left: 0,
      category: 1,
      type: 1,
      detiallist: [],
      RevenueList: [],
      Recharge: [
        {
          goodsPrice: "100",
          orderId: "123456789",
          type: "1",
          createTime: "2021-06-09 14:05:09",
        },
        {
          goodsPrice: "100",
          orderId: "123456789",
          type: "2",
          createTime: "2021-06-09 14:05:09",
        },
        {
          goodsPrice: "100",
          orderId: "123456789",
          type: "3",
          createTime: "2021-06-09 14:05:09",
        },
        {
          goodsPrice: "100",
          orderId: "123456789",
          type: "4",
          createTime: "2021-06-09 14:05:09",
        },
      ],
      pickingList: [],
      deliveryRecordsList: [],
      data: {
        success: true,
        data: {
          total: 264,
          pages: 7,
          page: 1,
          limit: 40,
        },
        errorCode: 0,
        errorMsg: null,
        errorData: null,
        errorCodeStr: null,
      },
      RevenueListPage: {
        moneyType: 1,
        page: 1,
        size: 30,
      },
      revenueListIsOver: "加载中",
      fenJieIsOver: "加载中",
      deliveryRecordsIsOver: "加载中",
      deliveryRecordsPage: {
        page: 1,
        size: 9,
        statusList: [10],
      },
      rechargeRecordsPage: {
        page: 1,
        size: 10,
      },
      userdecompseListPage: {
        page: 1,
        size: 12,
      },
      userdecompseListIsover: "加载中",
      rechargeRecordsIsover: "加载中",
      // 新的
      isShow: false,
      order: "",
      showSettingSound: false,
      curTab: 0,
      page4: 1,
      page1: 1,
      page2: 1,
      page3: 1,
      tableData1: [],
      tableData2: [],
      tableData: [],
      tableData4: [],
      over1: false,
      over2: false,
      over3: false,
      over4: false,
      accountFlow: {
        page: 1,
        limit: 50,
        isOver: false,
        lists: [],
      },
      offerFlow: {
        page: 1,
        limit: 50,
        isOver: false,
        lists: [],
      },
      showDateFilter: false,
      dateFilterIndex: 0,
      dateFilterLists: [
        [
          {
            name: "今天",
            type: "today",
          },
          {
            name: "昨天",
            type: "yesterday",
          },
          {
            name: "近7日",
            type: "week",
          },
          {
            name: "近30日",
            type: "month",
          },
        ],
      ],
      showTypeFilter: false,
      typeFilterIndex: 0,
      typeFilterLists: [
        [
          {
            name: "全部",
            type: "-1",
          },
          {
            name: "充值",
            type: "6",
          },
          {
            name: "回收",
            type: "2",
          },
        ],
      ],
      user: {
        level_info: {},
      },
      // 提取二级分类
      extractList: [
        {
          name: "提取完成",
          type: 1,
        },
        {
          name: "冻结中",
          type: 3,
        },
        {
          name: "申请提货",
          type: 4,
        },
        {
          name: "等待收货",
          type: 6,
        },
      ],
      currentExtract: 1,
      showOrderId: false,
      orderId: "",
    };
  },
  mounted() {
    this.changeTab(0);
    // setTimeout(() => {
    //   this.add();
    // }, 1000);
    // this.getlisttihuo();
  },
  methods: {
    //  查看支付单号
    showD(index) {
      console.log(index, "showOrderId");
      this.showOrderId = true;
      this.orderId = index;
      console.log(this.showOrderId, "orderId");
    },
    // 返回上级
    back() {
      this.$router.go(-1);
    },
    // tab切换
    changeTab(index) {
      switch (index) {
        case 0:
          this.curTab = 0;
          this.handleRevenueListType(1);
          break;
        case 1:
          this.curTab = 1;
          this.handleRevenueListType(2);
          break;
        case 2:
          this.curTab = 2;
          this.handletype(3);
          break;
        case 3:
          this.curTab = 3;
          this.handletype(1);
          break;
      }
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    rechargeScroll(e) {
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.userdecompseListIsover == "加载中") {
          this.rechargeRecordsPage.page++;
          setTimeout(() => {
            this.getrechangeList();
          }, 5);
        } else if (this.revenueListIsOver == "暂无更多") {
          this.$message({
            duration: 1000,
            message: "暂无更多",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
    userdecompseListScroll(e) {
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.userdecompseListIsover == "加载中") {
          this.userdecompseListPage.page++;
          setTimeout(() => {
            this.getuserfenjie();
          }, 5);
        }
      }
    },
    deliveryRecordsScroll(e) {
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.deliveryRecordsIsOver == "加载中") {
          this.deliveryRecordsPage.page++;
          setTimeout(() => {
            this.getlisttihuo();
          }, 5);
        } else if (this.deliveryRecordsIsOver == "暂无更多") {
          this.$message({
            duration: 1000,
            message: "暂无更多",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
    revenueListScroll(e) {
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        if (this.revenueListIsOver == "加载中") {
          this.RevenueListPage.page++;
          if (this.curTab == 0) {
            this.RevenueListPage.moneyType = 1;
          } else if (this.curTab == 1) {
            this.RevenueListPage.moneyType = 2;
          }
          setTimeout(() => {
            this.getlisr();
          }, 5);
        } else if (this.revenueListIsOver == "暂无更多") {
          this.$message({
            duration: 1000,
            message: "暂无更多",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
    handleRevenueListType(res) {
      this.RevenueListPage.moneyType = res;
      this.RevenueListPage.page = 1;
      this.RevenueList = [];
      this.getlisr();
    },
    add() {
      this.data.data.list = [
        {
          id: "23547",
          appId: 730,
          itemId: "23547",
          itemName: "AWP | 狩猎网格 (久经沙场)",
          marketHashName: "AWP | Safari Mesh (Field-Tested)",
          shortName: "AWP | 狩猎网格",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgU2FmYXJpIE1lc2ggKEZpZWxkLVRlc3RlZCk=.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_uncommon_weapon",
          rarityName: "工业级",
          rarityColor: "#5E98D9",
          exterior: "wearcategory2",
          exteriorName: "久经沙场",
          exteriorColor: "#f0ad4e",
          sellType: 1,
          quantity: 819,
          currencyId: 0,
          price: "0.05",
          subsidyPrice: "0.26",
          sellerPrice: "0.26",
          cnyPrice: "0.26",

          recommendTagInfo: [
            {
              id: null,
              recommendTag: "热度过万",
              stairName: null,
              secondLevelName: null,
              detailTag: "热度过万",
              tagColour: "#ff0000",
              detailUrl: "c5game://main.app/popularSkin",
              recommendWeight: null,
              createTime: null,
              updateTime: null,
              attrKey: null,
              valueKey: null,
              status: null,
              recommendType: null,
              attrValueId: null,
              urlType: 1,
            },
          ],
          subsidyTag: null,
        },
        {
          id: "24507",
          appId: 730,
          itemId: "24507",
          itemName: "AWP | 狩猎网格 (破损不堪)",
          marketHashName: "AWP | Safari Mesh (Well-Worn)",
          shortName: "AWP | 狩猎网格",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgU2FmYXJpIE1lc2ggKFdlbGwtV29ybik=.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_uncommon_weapon",
          rarityName: "工业级",
          rarityColor: "#5E98D9",
          exterior: "wearcategory3",
          exteriorName: "破损不堪",
          exteriorColor: "#d9534f",
          sellType: 1,
          quantity: 53,
          currencyId: 0,
          price: "0.08",
          subsidyPrice: "0.45",
          sellerPrice: "0.45",
          cnyPrice: "0.45",

          recommendTagInfo: [],
          subsidyTag: null,
        },
        {
          id: "22424",
          appId: 730,
          itemId: "22424",
          itemName: "AWP | 狩猎网格 (略有磨损)",
          marketHashName: "AWP | Safari Mesh (Minimal Wear)",
          shortName: "AWP | 狩猎网格",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgU2FmYXJpIE1lc2ggKE1pbmltYWwgV2Vhcik=.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_uncommon_weapon",
          rarityName: "工业级",
          rarityColor: "#5E98D9",
          exterior: "wearcategory1",
          exteriorName: "略有磨损",
          exteriorColor: "#5cb85c",
          sellType: 1,
          quantity: 417,
          currencyId: 0,
          price: "0.09",
          subsidyPrice: "0.57",
          sellerPrice: "0.57",
          cnyPrice: "0.57",

          subsidyTag: null,
        },
        {
          id: "22353",
          appId: 730,
          itemId: "22353",
          itemName: "AWP | 狩猎网格 (战痕累累)",
          marketHashName: "AWP | Safari Mesh (Battle-Scarred)",
          shortName: "AWP | 狩猎网格",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgU2FmYXJpIE1lc2ggKEJhdHRsZS1TY2FycmVkKQ==.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_uncommon_weapon",
          rarityName: "工业级",
          rarityColor: "#5E98D9",
          exterior: "wearcategory4",
          exteriorName: "战痕累累",
          exteriorColor: "#B65C59",
          sellType: 1,
          quantity: 535,
          currencyId: 0,
          price: "0.11",
          subsidyPrice: "0.69",
          sellerPrice: "0.69",
          cnyPrice: "0.69",

          subsidyTag: null,
        },
        {
          id: "553489642",
          appId: 730,
          itemId: "553489642",
          itemName: "AWP | 毛细血管 (久经沙场)",
          marketHashName: "AWP | Capillary (Field-Tested)",
          shortName: "AWP | 毛细血管",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgQ2FwaWxsYXJ5IChGaWVsZC1UZXN0ZWQp.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_rare_weapon",
          rarityName: "军规级",
          rarityColor: "#4B69FF",
          exterior: "wearcategory2",
          exteriorName: "久经沙场",
          exteriorColor: "#f0ad4e",
          sellType: 1,
          quantity: 870,
          currencyId: 0,
          price: "0.16",
          subsidyPrice: "1",
          sellerPrice: "1",
          cnyPrice: "1",
          itemInfo: {
            quality: "",
            qualityName: "",
            qualityColor: "",
            rarity: "rarity_rare_weapon",
            rarityName: "军规级",
            rarityColor: "#4B69FF",
            type: "csgo_type_sniperrifle",
            typeName: "狙击步枪",
            slot: "",
            slotName: "",
            hero: "",
            heroName: "",
            heroAvatar: "",
            exterior: "wearcategory2",
            exteriorName: "久经沙场",
            exteriorColor: "#f0ad4e",
            weapon: "weapon_awp",
            weaponName: "AWP",
            itemSet: "set_community_25",
            itemSetName: "棱彩2号收藏品",
            stickerCapsule: "",
            stickerCapsuleName: "",
            patchCapsule: "",
            patchCapsuleName: "",
            customPlayer: "",
            customPlayerName: "",
            category: "",
            categoryName: "",
            item: "",
            itemName: null,
          },
          recommendTagInfo: [
            {
              id: null,
              recommendTag: "热度过万",
              stairName: null,
              secondLevelName: null,
              detailTag: "热度过万",
              tagColour: "#ff0000",
              detailUrl: "c5game://main.app/popularSkin",
              recommendWeight: null,
              createTime: null,
              updateTime: null,
              attrKey: null,
              valueKey: null,
              status: null,
              recommendType: null,
              attrValueId: null,
              urlType: 1,
            },
          ],
          subsidyTag: null,
        },
        {
          id: "22318",
          appId: 730,
          itemId: "22318",
          itemName: "AWP | 响尾蛇 (久经沙场)",
          marketHashName: "AWP | Pit Viper (Field-Tested)",
          shortName: "AWP | 响尾蛇",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgUGl0IFZpcGVyIChGaWVsZC1UZXN0ZWQp.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_mythical_weapon",
          rarityName: "受限",
          rarityColor: "#8847FF",
          exterior: "wearcategory2",
          exteriorName: "久经沙场",
          exteriorColor: "#f0ad4e",
          sellType: 1,
          quantity: 971,
          currencyId: 0,
          price: "0.23",
          subsidyPrice: "1.42",
          sellerPrice: "1.42",
          cnyPrice: "1.42",
          itemInfo: {
            quality: "",
            qualityName: "",
            qualityColor: "",
            rarity: "rarity_mythical_weapon",
            rarityName: "受限",
            rarityColor: "#8847FF",
            type: "csgo_type_sniperrifle",
            typeName: "狙击步枪",
            slot: "",
            slotName: "",
            hero: "",
            heroName: "",
            heroAvatar: "",
            exterior: "wearcategory2",
            exteriorName: "久经沙场",
            exteriorColor: "#f0ad4e",
            weapon: "weapon_awp",
            weaponName: "AWP",
            itemSet: "set_italy",
            itemSetName: "意大利小镇收藏品",
            stickerCapsule: "",
            stickerCapsuleName: "",
            patchCapsule: "",
            patchCapsuleName: "",
            customPlayer: "",
            customPlayerName: "",
            category: "",
            categoryName: "",
            item: "",
            itemName: null,
          },
          recommendTagInfo: [
            {
              id: null,
              recommendTag: "热度过万",
              stairName: null,
              secondLevelName: null,
              detailTag: "热度过万",
              tagColour: "#ff0000",
              detailUrl: "c5game://main.app/popularSkin",
              recommendWeight: null,
              createTime: null,
              updateTime: null,
              attrKey: null,
              valueKey: null,
              status: null,
              recommendType: null,
              attrValueId: null,
              urlType: 1,
            },
          ],
          subsidyTag: null,
        },
        {
          id: "553489767",
          appId: 730,
          itemId: "553489767",
          itemName: "AWP | 毛细血管 (战痕累累)",
          marketHashName: "AWP | Capillary (Battle-Scarred)",
          shortName: "AWP | 毛细血管",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgQ2FwaWxsYXJ5IChCYXR0bGUtU2NhcnJlZCk=.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_rare_weapon",
          rarityName: "军规级",
          rarityColor: "#4B69FF",
          exterior: "wearcategory4",
          exteriorName: "战痕累累",
          exteriorColor: "#B65C59",
          sellType: 1,
          quantity: 70,
          currencyId: 0,
          price: "0.35",
          subsidyPrice: "2.16",
          sellerPrice: "2.16",
          cnyPrice: "2.16",
          itemInfo: {
            quality: "",
            qualityName: "",
            qualityColor: "",
            rarity: "rarity_rare_weapon",
            rarityName: "军规级",
            rarityColor: "#4B69FF",
            type: "csgo_type_sniperrifle",
            typeName: "狙击步枪",
            slot: "",
            slotName: "",
            hero: "",
            heroName: "",
            heroAvatar: "",
            exterior: "wearcategory4",
            exteriorName: "战痕累累",
            exteriorColor: "#B65C59",
            weapon: "weapon_awp",
            weaponName: "AWP",
            itemSet: "set_community_25",
            itemSetName: "棱彩2号收藏品",
            stickerCapsule: "",
            stickerCapsuleName: "",
            patchCapsule: "",
            patchCapsuleName: "",
            customPlayer: "",
            customPlayerName: "",
            category: "",
            categoryName: "",
            item: "",
            itemName: null,
          },
          recommendTagInfo: [
            {
              id: null,
              recommendTag: "热度过万",
              stairName: null,
              secondLevelName: null,
              detailTag: "热度过万",
              tagColour: "#ff0000",
              detailUrl: "c5game://main.app/popularSkin",
              recommendWeight: null,
              createTime: null,
              updateTime: null,
              attrKey: null,
              valueKey: null,
              status: null,
              recommendType: null,
              attrValueId: null,
              urlType: 1,
            },
          ],
          subsidyTag: null,
        },
        {
          id: "553489579",
          appId: 730,
          itemId: "553489579",
          itemName: "AWP | 毛细血管 (略有磨损)",
          marketHashName: "AWP | Capillary (Minimal Wear)",
          shortName: "AWP | 毛细血管",
          imageUrl:
            "https://img.zbt.com/e/steam/item/730/QVdQIHwgQ2FwaWxsYXJ5IChNaW5pbWFsIFdlYXIp.png",
          type: "csgo_type_sniperrifle",
          typeName: "狙击步枪",
          quality: "",
          qualityName: "",
          qualityColor: "",
          rarity: "rarity_rare_weapon",
          rarityName: "军规级",
          rarityColor: "#4B69FF",
          exterior: "wearcategory1",
          exteriorName: "略有磨损",
          exteriorColor: "#5cb85c",
          sellType: 1,
          quantity: 379,
          currencyId: 0,
          price: "0.39",
          subsidyPrice: "2.46",
          sellerPrice: "2.46",
          cnyPrice: "2.46",
          itemInfo: {
            quality: "",
            qualityName: "",
            qualityColor: "",
            rarity: "rarity_rare_weapon",
            rarityName: "军规级",
            rarityColor: "#4B69FF",
            type: "csgo_type_sniperrifle",
            typeName: "狙击步枪",
            slot: "",
            slotName: "",
            hero: "",
            heroName: "",
            heroAvatar: "",
            exterior: "wearcategory1",
            exteriorName: "略有磨损",
            exteriorColor: "#5cb85c",
            weapon: "weapon_awp",
            weaponName: "AWP",
            itemSet: "set_community_25",
            itemSetName: "棱彩2号收藏品",
            stickerCapsule: "",
            stickerCapsuleName: "",
            patchCapsule: "",
            patchCapsuleName: "",
            customPlayer: "",
            customPlayerName: "",
            category: "",
            categoryName: "",
            item: "",
            itemName: null,
          },
          recommendTagInfo: [
            {
              id: null,
              recommendTag: "热度过万",
              stairName: null,
              secondLevelName: null,
              detailTag: "热度过万",
              tagColour: "#ff0000",
              detailUrl: "c5game://main.app/popularSkin",
              recommendWeight: null,
              createTime: null,
              updateTime: null,
              attrKey: null,
              valueKey: null,
              status: null,
              recommendType: null,
              attrValueId: null,
              urlType: 1,
            },
          ],
          subsidyTag: null,
        },
      ];
      this.$forceUpdate();
    },
    getuserfenjie() {
      userdecompseList(this.userdecompseListPage)
        .then((res) => {
          console.log("userdecompseList", res.data.rows);
          this.pickingList.push(...res.data.rows);
          if (res.data.rows.length < this.userdecompseListPage.size) {
            this.revenueListIsOver = "暂无更多";
          }
        })
        .catch((err) => {
          console.log("catch", err);
        });
    },
    handlecategory(res) {
      this.category = res;
      this.detiallist = [];
      this.data.data.list = [];
      let key = null;
      switch (res) {
        case 1:
          key = 10;
          break;
        case 2:
          this.deliveryRecordsList = [];
          this.getuserfenjie();
          break;
        case 3:
          key = 12;
          break;
        case 4:
          key = 1;
          break;

        case 6:
          key = 2;
          break;

        default:
          break;
      }
      console.log(key);
      if (key != null) {
        this.deliveryRecordsIsOver = "加载中";
        this.deliveryRecordsList = [];
        this.deliveryRecordsPage.statusList.splice(0, 1, key);
        this.getlisttihuo();
      }
      // if (res == 4) {
      //   res = 0;
      // } else if (res == 1) {
      //   res = 10;
      // } else if (res == 5) {
      //   res = 1;
      // } else if (res == 6) {
      //   res == 3;
      // } else if (res == 2) {
      //   this.getuserfenjie();
      // }
      // // res = 0;
      // if (res != 2) {
      //   getExtractBillAPI(res).then((res) => {
      //     this.pickingList = res.data.rows;
      //   });
      // }
    },
    handletype(res) {
      this.type = res;
      if (res == 1) {
        this.deliveryRecordsPage.page = 1;
        this.deliveryRecordsList = [];
        this.getlisttihuo();
      } else if (res == 2) {
        this.RevenueListPage.page = 1;
        this.RevenueList = [];
        this.getlisr();
      } else if (res == 3) {
        this.rechargeRecordsPage.page = 1;
        this.Recharge = [];
        this.getrechangeList();
      } else if (res == 4) {
        this.pickingList = [];
        this.deliveryRecordsList = [];
        this.pickingList = [];
        this.userdecompseListPage.page = 1;
        this.getuserfenjie();
      }
    },
    getrechangeList() {
      rechargeRecords(this.rechargeRecordsPage).then((res) => {
        this.Recharge.push(...res.data.data.records);
        if (res.data.data.records.length < this.rechargeRecordsPage.size) {
          this.rechargeRecordsIsover = "暂无更多";
        }
      });
    },
    getlisr() {
      getUserLogList(this.RevenueListPage).then((res) => {
        this.RevenueList.push(...res.data.data);
        console.log(this.RevenueList, "测试测试");
        if (res.data.data.length < this.RevenueListPage.size) {
          this.revenueListIsOver = "暂无更多";
        }
      });
    },
    getlisttihuo() {
      deliveryRecords(this.deliveryRecordsPage).then((res) => {
        console.log("deliveryRecords", res);
        this.deliveryRecordsList.push(...res.data.data);
        this.pickingList = [];
        if (this.deliveryRecordsPage.size > res.data.data.length) {
          console.log("deliveryRecordsIsOver", 1);
          this.deliveryRecordsIsOver = "暂无更多";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.account-flow {
  --head-height: 14 * 4.2px;
}

.acc-record-page .acc-record-page-content {
  width: 100%;
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-top: 5rem;
  // margin-top: 5 * 4.2px;
}

.acc-record-page .type-tab-wrap {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding-top: 3.47 * 4.2px;
  margin: 0 auto;
  // padding-left: 2 * 4.2px;
  color: #fff;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
}

.acc-record-page .type-tab-wrap .type-tab-item {
  // width: 27.73*4.2px;
  width: 21 * 4.2px;
  height: 9.33 * 4.2px;
  background: url("../../../assets/image3/share/notSelectedBack.png") no-repeat
    0 0;
  // background-size: 21*4.2px 9.33*4.2px;
  background-size: 100% 100%;
  float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffffff;
  // margin-right: 2 * 4.2px;
  font-size: 3.33 * 4.2px;
}

.acc-record-page .type-tab-wrap .type-tab-item.sel {
  // background: url(data:image/png;base64,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) no-repeat 0 0;
  background: url("../../../assets/image3/share/selectBack.png") no-repeat 0 0;
  // background-size: 27.73*4.2px 9.33*4.2px;
  background-size: 100% 100%;
}

.acc-record-page .acc-record-content-wrap {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  width: 92%;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding: 2.4 * 4.2px 2.67 * 4.2px 0 2.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  // height: calc(100vh - 120px);
  height: 76vh;
  background: linear-gradient(320deg, #05164e 0%, #0b2db4 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
  border-image: linear-gradient(
      96deg,
      rgba(179, 223, 255, 1),
      rgba(48, 168, 255, 0),
      rgba(172, 220, 255, 1)
    )
    1 1;
  margin: 15px auto 0;
}

.acc-record-page .acc-record-content-wrap:after {
  content: "";
  display: block;
  width: 100 * 4.2px;
  height: 5.47 * 4.2px;
  background: url("../../../assets/images/gradient_bg.png") no-repeat 0 0;
  background-size: 100 * 4.2px 5.47 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.acc-record-page .acc-record-content-wrap .filter-box-wrap {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding-bottom: 4.13 * 4.2px;
  float: left;
}

.acc-record-page .acc-record-content-wrap .filter-box {
  width: auto;
  height: 8.53 * 4.2px;
  float: left;
  margin-right: 4 * 4.2px;
}

.acc-record-page .acc-record-content-wrap .filter-box .filter-btn {
  width: 39.47 * 4.2px;
  height: 8.53 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASgAAABACAMAAACeCRqoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURSk0lClBuypFxP///yhBtSpEwSo+sig3lSg2mik2oChP3ig8oig+qylIzShHyShT5SlO1io4mihQ4TVd6SlL0ilN2Co9qCo4nShK0ik9qSg9rChQ4ihKzihP2yhN1ys7oyhJySdS5QAAAChO3v///yhDvCg5oSlGxyhM0ys1mChEwis7pyk8qilN2ihO2yk+sDRc6Sk3nypAtilCuihM1yhS5ys9rSdQ4f///ydS5ihO2ChJyf///yhS5ClJzShN2ShN3ChR4ydQ4ihU7CdM1ihJzChQ4ChS5ihT6So6qClAtCo/sShCvSg/tydL0ydHzChQ3ilS4idT5yhT6SdIyik+sylIyCpEwChL0SlT6ylGwSlFwipDvSlO2ilO2ChR5ChS6CpHxCpHxylDwSdN1ihL0/f5/yhL1ihGwyhL0ChLzylM0ihN1ylQ3SlR5DRd6yhS6ShT6ShR5////////yg3mSs9sChN2SpAuClHyClQ4f///////ydK0ShJzipFxidN2ylP3ihR4DNd7zRd6yhR4idP4ShU7TNd7ydU8ChU7ihU7TFg+v///////ylK0ShLzipDuihIyydP2yhP3ydO3ShS5zNe7TRd7TVe6yhQ4CdQ5ChP4ihU6ShW8jNd7ihO1yg/tSdIzChR4SlS5ChT6TJd8ClAsSpDtylHyypCvydP3SdM2SlR5ylR5ShU6ylQ4jJe8iha+ihZ9yo/rilJzyhHyzNc6v///////////yhM0ipGxihP3yhR5ShS6ihV7ChV7yhV7jNd8TRd7ShV8ChS6ShT5zJe8ydV8ChV8DJe8yhX8zJf8yhX9TFe9SlU6zFf9f///yhV7TJf9ydV7ihV7ChY+TNd7CdT6v///////yhY+ShY9ydM1ChIzilQ3yhV8P///ylY8////////6++9yhX9f///ylU6jFg+P///zVi9zBg+DJe8f///////zFg+ShZ+P///////ylZ+ShZ9////////3mU8DRj+////zBb8P///9vj/f///7wCjzYAAAD/dFJOU0VeZ/daYlZGR0uLTVJxbJp9SZKld4RPSXhQU5NyhX5ObZsAjNpfTGl5SGVOUYSGV6ZKW11/nlSP55uAbAWZcIGHlJWrfG2NnKZPWFVgWXtvjZaipW5XamF0qWNkYYODmJ5oaGN7evt9ZnN0doGJl6eho6ESlkZUflxrkFwNdXNniIqOsaiYkK6ztrGt4oDzdXNccIiOiZ+uramSlZSkv7V/WW6RlqC3WFxrYIiCnZ2nl73h2FV2bKtd+V54ZpGaqLG0srqsuJ+gwLy6w8THyMupz++s07Cz36qoBvrb1HxykLl*4.2px4fc0szZqtr02N25ZOjf2Z4X3NUBFL3j8rbq8RQo7s0AAAt6SURBVHja7Zx3XJpnHsAxCGdQTKSmQRGVUgRRcIEEUjYILkBQxL3rnr267txxJb0aNZpEzTZJs5M243pNYvZodo2dd93XvcftO+95XoyjbfqJ+eQP5c33Tz+8n9fn+/k9v+f3rBfzCnaKZe+/+RjCm19/g/1F/v3XTx6f23zy+CvYB8Kz3//w2DQwb/3rGci3X342jv3wH39H/vjE75aN79jU0dHSsnbduWPrV6woLQ208tH43Oejfz4ye2DjSktXrH/93Lq1LR2bdnx16H/Y3z41XRT2meeff/61H797YfzZP/z+sUlPY6uUN0e0pnJjRUU6f59GIxTSaIsgtLnOovuDJhRqNHx+RYVxg3ZEuWrs1c4nZ5hCRL325xf+NtPTzTe0G4zb+/kamjitJGZQLqfMU0j3BPJTuVwRM9wqpmnSt5drE0bHXp1hCooCnv4y05OpfHv6fpq4NUZOGdj2bvOaMAOdTvgl6HMBwgOBTjeENQtqByiKErEmvcwEVE03BUT93FNFugZKItUKwuiE4j29Mi4VgcPhUOc+HIQlswJpGJcr21NMoK+pJSlaafwy06ft00wBUT/+1BOflnaQsk0QRmjq5VKXpOwtEol4VZ7zicWzBjxUtVkkkqYuocr6CGu2yUto/eUHRqdMYbDffveT/ERrVQwIDIQ9XGqKVMRbrMrWsVgs8jzF9Z5AfvoSi5WTrVrMK0qlyoAqhXifUaucNIXBfvmT8S5NMdBM6ONyUot4udk5LHJhl6Vgtcd8gzhL4DP1+QV1ha4snYon5TQSBJQSTcWUKQz2s5meDlIE9D5uSlGVSsdy7Sqo9yD26GNjvSHLrXjPZaz/ovOsga1Sx27tkRDrLYWsbN5eal8Y6aBw+6QpDHamp8E2QxM3VZSbzXKtW02UbFUvrzEzmZmZGRkLbJyMjEwm01zjrNYT84+wVCJOI71tWFihnchTmBc/n+5pqI3eyCny1JG78omSWO8aZmZDHpudlJiIQwGJSWx23oJMs/NWYoGrjpcqo7cd1BgPWMc+zLIP73j647JxioAgS+W9Ta6rl2wFljLy2Im4+OSoKAaDYWfzgEZG7Y7HJbIbmM56jyM5nntldFLJvvJPYT31A+b9p6Z7auLu9cwpzJfE7mJm5iVlxUcx7EJCngsOtkcDwcHV3SF2jGQcu8GsJtaxPFMbwyjiftMoqNG/xzwx5WkIeCrKZdW9o3dmNrATgSXgyD56S0RcXEBAAN7GAU2M2xkRbR8cwkjOymN6E+tyeJw+gYJWljDW+eTnmClPg20E4IlsIarNDeysZIYdsBQRF4CPPBwa6j4PcZoFyAOhoZWReHzcFqAKxwamjuhEVMK2Ej4IqUNYzKSng2102V7oyZuZl5jMCIGW8JGh4H3+ALd5x6OzAXkCNBMoq8THRVcz4tlMtYeram/jGjkMqa+sop74E6gzKYbGVE+WhXiUycZFhQRHRwRAS/5uj4b7+fl5QRzv4DVXcbx/4OOgoeFu/k6V+C3VDFyeWV/A4nEI21rTtat2IKKgJ5pC0MTh5dSBeGLHM7rtI0AwAUvhfuDlPj4+C9EAaKePo5efm1MoNJXV4Ew8ki2VrVFoypWboCjoid86QOcWvV34jhp6qo4OgJqgJcRRUNDS+YvLPTDx06AgaMsr3D8UHx2SzGZuzWfxqASSePtIBxAFPVXQ5M19qbnkfL05D8eo3oKvBNHk5wUtBYE3+fr6Otg+oJVAWdBCH8dwp8q4YAYOhFShKrWvtiRd24LFvAk8mdLTBghcka5O4tyQGNUdjQ91smoCliYcPf0bm2fClkuQj5ebE34LCCmz3qIrgn1*4.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)
    no-repeat 0 0;
  background-size: 39.47 * 4.2px 8.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.acc-record-page .acc-record-content-wrap .filter-box .text {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  line-height: 8.53 * 4.2px;
  text-align: center;
}

.acc-record-page .acc-record-content-wrap .filter-box .right-icon {
  width: 10.27 * 4.2px;
  height: 8.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.acc-record-page .acc-record-content-wrap .filter-box .right-icon .line {
  width: 1px;
  height: 2.93 * 4.2px;
  margin-right: 2.4 * 4.2px;
}

.acc-record-page .acc-record-content-wrap .filter-box .right-icon .arrow-icon {
  width: 4.93 * 4.2px;
  height: 2.93 * 4.2px;
}

.acc-record-page .acc-record-content-wrap .filter-box .select-box {
  width: 39.47 * 4.2px;
  height: auto;
}

.acc-record-page .acc-record-content-wrap .filter-box .select-box .sort-item {
  width: 100%;
  height: 10.67 * 4.2px;
  line-height: 10.67 * 4.2px;
  text-align: center;
}

.acc-record-page .acc-record-content-wrap .record-content-inner {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 12;
}

// .header{
// 	.item{
// 		background: url("../../../assets/images/table_header_bg_1.png")
// 		  no-repeat 0 0;
// 		  margin: 0 1px;
// 		  background-position: -10*4.2px 0;
// 		  background-size: auto 100%;
// 		  &:nth-child(1) {
// 		  	background-position: 0 0;
// 		  }
// 		  &:last-child{
// 			  background-position: 100% 0;
// 		  }
// 	}

// }
.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .balance-record-header {
  width: 91.67 * 4.2px;
  height: 9.47 * 4.2px;
  // background: url("../../../assets/images/table_header_bg_1.png")
  //   no-repeat 0 0;
  // background-size: 94.67*4.2px 7.47*4.2px;
  color: #fff;
  font-size: 3.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background: #09183e;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .balance-record-header
  > div {
  height: 9.47 * 4.2px;
  line-height: 9.47 * 4.2px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .take-record-header {
  width: 91.67 * 4.2px;
  height: 9.47 * 4.2px;
  // background: url("../../../assets/images/table_header_bg_2.png") no-repeat 0 0;
  // background-size: 91.67 * 4.2px 8.47 * 4.2px;
  color: #fff;
  font-size: 3.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background: #09183e;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .take-record-header
  > div {
  height: 9.47 * 4.2px;
  line-height: 9.47 * 4.2px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .tran-time {
  width: 187.546px;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .tran-type {
  width: 110px;
  // white-space: nowrap;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .change-price {
  width: 18.4 * 4.2px;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .increase {
  color: #ffe3c2 !important;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .balance-price {
  width: 80px;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .take-time {
  width: 27.47 * 4.2px;
}

.acc-record-page .acc-record-content-wrap .record-content-inner .prod-info {
  width: 53.33 * 4.2px;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .buy-back-price {
  width: 14.13 * 4.2px;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;.top-box
  // -ms-flex: 1;
  // flex: 1;
  height: 75vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .content-item {
  width: 100%;
  height: 11.47 * 4.2px;
  line-height: 11.47 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .content-item:nth-child(2n + 1) {
  background: #101668;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .content-item:nth-child(2n) {
  background: #09183e;
}

.lue {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .content-item:after {
  content: "";
  display: block;
  width: 94.67 * 4.2px;
  height: 1px;
  // background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsYAAAABCAYAAADdGmiQAAAAAXNSR0IArs4c6QAAADpJREFUSEtjNHXd+p9hFIyGwGgI0CUETu/2ZiTGotF8SUwoDX81o+ll+McxNX04ml6oGZqjZo3UEAAAzW4OMDfgwZoAAAAASUVORK5CYII=)
  //   no-repeat 0 0;
  // background-size: 94.67*4.2px 1px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: #2e2d69;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .content-item
  > div {
  // height: 7.47 * 4.2px;
  // line-height: 7.47 * 4.2px;
  text-align: center;
  font-size: 12px;
  color: #fff;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item {
  width: 100%;
  // height: 14.67*4.2px;
  height: 7.47 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 2.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #fff;
  position: relative;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item:after {
  content: "";
  display: block;
  width: 94.67 * 4.2px;
  height: 1px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsYAAAABCAYAAADdGmiQAAAAAXNSR0IArs4c6QAAADZJREFUSEtjNHXd+p9hFIyGwGgIYA2B07u9GYkJmtF8REwojaoZDYHREBgNgZETAqP1x9CMawBJGAowe11xtwAAAABJRU5ErkJggg==)
    no-repeat 0 0;
  background-size: 94.67 * 4.2px 1px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .take-time {
  height: 7.47 * 4.2px;
  line-height: 7.47 * 4.2px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding: 0 2.67*4.2px;
  text-align: center;
}
.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .take-time
  img {
  height: 100%;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .prod-info {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .prod-info
  image {
  width: 7.07 * 4.2px;
  height: 5.73 * 4.2px;
  margin-right: 1.87 * 4.2px;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .prod-info
  .info-box {
  width: 44.4 * 4.2px;
  height: auto;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .prod-info
  .info-box
  .prod-name {
  // margin-bottom: 2*4.2px;
  text-align: center;
}

.acc-record-page
  .acc-record-content-wrap
  .record-content-inner
  .scroll-content-box
  .take-record-item
  .buy-back-price {
  height: 7.47 * 4.2px;
  line-height: 7.47 * 4.2px;
  text-align: center;
}

.top-box {
  width: 370px;
  height: 2rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 1rem;

  // padding: 1.73*4.2px 0 0 5.47*4.2px;
}

.top-box .left {
  width: auto;
  height: 9.33 * 4.2px;
  // float: left;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: space-between;
}

.top-box .left .roll-type-item {
  width: 21.07 * 4.2px * 0.98;
  height: 9.33 * 4.2px * 0.98;
  line-height: 9.33 * 4.2px * 0.98;
  background: url("../../../assets/images/tab_short.png") no-repeat 0 0;
  background-size: 21.07 * 4.2px * 0.98 9.33 * 4.2px * 0.98;
  text-align: center;
  color: #ffffff;
  // margin-right: 2.67 * 4.2px;
}

.top-box .left .roll-type-item.sel {
  background: url("../../../assets/images/tab_short_active.png") no-repeat 0 0;
  background-size: 21.07 * 4.2px * 0.98 9.33 * 4.2px * 0.98;
}

.top-box .right-search-box {
  width: 39.87 * 4.2px;
  height: 7.87 * 4.2px;
  background: url("../../../assets/images/k20.png") no-repeat 0 0;
  background-size: 39.87 * 4.2px 7.87 * 4.2px;
  float: right;
  margin: 0.67 * 4.2px 5.33 * 4.2px 0 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.top-box .right-search-box .search-input {
  width: 30.67 * 4.2px;
  height: 7.87 * 4.2px;
}

.top-box .right-search-box .search-input input {
  width: 100%;
  height: 7.87 * 4.2px;
  text-indent: 2.4 * 4.2px;
  font-size: 2.67 * 4.2px;
  background: transparent;
}

.top-box .right-search-box .search-input input::-webkit-input-placeholder {
  font-size: 2.67 * 4.2px;
}

.top-box .right-search-box .search-input input::-moz-placeholder {
  font-size: 2.67 * 4.2px;
}

.top-box .right-search-box .search-input input::-ms-input-placeholder {
  font-size: 2.67 * 4.2px;
}

.top-box .right-search-box .search-input input::placeholder {
  font-size: 2.67 * 4.2px;
}

.top-box .right-search-box .search-btn {
  width: 8.8 * 4.2px;
  height: 7.87 * 4.2px;
  background: url("../../../assets/images/search-icon.png") no-repeat 0 center;
  background-size: 6.67 * 4.2px 6.27 * 4.2px;
}

.appview {
  height: 100vh !important;
}

.zz-page {
  overflow: visible;
}

.w50 {
  width: 50px !important;
}

.w80 {
  width: 80px !important;
}

.w120 {
  width: 120px !important;
}

.w200 {
  width: 200px;
}

.w300 {
  width: 300px;
}

.w400 {
  width: 400px;
}

.w500 {
  width: 500px;
}

.w600 {
  width: 600px;
}

.w700 {
  width: 700px;
}

@media only screen and (max-width: 430px) {
  .top-box {
    width: 90vw;
    height: 2rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0rem;
    z-index: 99;

    // padding: 1.73*4.2px 0 0 5.47*4.2px;
  }
  .account-flow {
    --head-height: 14vw;
  }

  .acc-record-page .acc-record-page-content {
    width: 100%;
    // margin-top: 5vw;
  }

  .acc-record-page .type-tab-wrap .type-tab-item {
    width: 21vw;
    height: 9.33vw;
    font-size: 3.33vw;
    // margin-right: 2vw;
  }

  .acc-record-page .type-tab-wrap .type-tab-item.sel {
    // background: url(data:image/png;base64,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) no-repeat 0 0;
    background: url("../../../assets/image3/share/selectBack.png") no-repeat 0 0;
    background-size: 100% 100%;
  }

  .acc-record-page .acc-record-content-wrap:after {
    width: 100vw;
    height: 5.47vw;

    background-size: 100vw 5.47vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box-wrap {
    // padding-bottom: 4.13vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box {
    height: 8.53vw;
    margin-right: 4vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box .filter-btn {
    width: 39.47vw;
    height: 8.53vw;

    background-size: 39.47vw 8.53vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box .text {
    line-height: 8.53vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box .right-icon {
    width: 10.27vw;
    height: 8.53vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box .right-icon .line {
    width: 1px;
    height: 2.93vw;
    margin-right: 2.4vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .filter-box
    .right-icon
    .arrow-icon {
    width: 4.93vw;
    height: 2.93vw;
  }

  .acc-record-page .acc-record-content-wrap .filter-box .select-box {
    width: 39.47vw;
    height: auto;
  }

  .acc-record-page .acc-record-content-wrap .filter-box .select-box .sort-item {
    width: 100%;
    height: 10.67vw;
    line-height: 10.67vw;
    text-align: center;
  }

  .acc-record-page .acc-record-content-wrap .record-content-inner {
    width: 100%;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .balance-record-header {
    width: 91.67vw;
    height: 9.47vw;

    font-size: 3.33vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .balance-record-header
    > div {
    height: 9.47vw;
    line-height: 9.47vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .take-record-header {
    width: 91.67vw;
    height: 9.47vw;

    background-size: 91.67vw 9.47vw;
    font-size: 3.33vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .take-record-header
    > div {
    height: 9.47vw;
    line-height: 9.47vw;
  }

  .acc-record-page .acc-record-content-wrap .record-content-inner .tran-time {
    width: 187.546px;
  }

  .acc-record-page .acc-record-content-wrap .record-content-inner .tran-type {
    width: 110px;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .change-price {
    width: 18.4vw;
  }

  .acc-record-page .acc-record-content-wrap .record-content-inner .take-time {
    width: 27.47vw;
  }

  .acc-record-page .acc-record-content-wrap .record-content-inner .prod-info {
    width: 53.33vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .buy-back-price {
    width: 14.13vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .content-item {
    height: 11.47vw;
    line-height: 11.47vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .content-item:after {
    width: 94.67vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .take-record-item {
    width: 100%;
    height: 7.47vw;
    font-size: 2.67vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .take-record-item:after {
    width: 94.67vw;
    height: 1px;

    background-size: 94.67vw 1px;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .take-record-item
    .take-time {
    height: 7.47vw;
    line-height: 7.47vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .take-record-item
    .prod-info
    image {
    width: 7.07vw;
    height: 5.73vw;
    margin-right: 1.87vw;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .take-record-item
    .prod-info
    .info-box {
    width: 44.4vw;
    height: auto;
  }

  .acc-record-page
    .acc-record-content-wrap
    .record-content-inner
    .scroll-content-box
    .take-record-item
    .buy-back-price {
    height: 7.47vw;
    line-height: 7.47vw;
  }

  .top-box .left {
    height: 9.33vw;
  }

  .top-box .left .roll-type-item {
    width: 21.07vw * 0.98;
    height: 9.33vw * 0.98;
    line-height: 9.33vw * 0.98;
    background: url("../../../assets/images/tab_short.png") no-repeat 0 0;
    background-size: 21.07vw * 0.98 9.33vw * 0.98;
    text-align: center;
    color: #ffffff;
    // margin-right: 2.67vw;
  }

  .top-box .left .roll-type-item.sel {
    background: url("../../../assets/images/tab_short_active.png") no-repeat 0 0;
    background-size: 21.07vw * 0.98 9.33vw * 0.98;
  }

  .top-box .right-search-box {
    width: 39.87vw;
    height: 7.87vw;

    background-size: 39.87vw 7.87vw;
    margin: 0.67vw 5.33vw 0 0;
  }

  .top-box .right-search-box .search-input {
    width: 30.67vw;
    height: 7.87vw;
  }

  .top-box .right-search-box .search-input input {
    width: 100%;
    height: 7.87vw;
    text-indent: 2.4vw;
    font-size: 2.67vw;
  }

  .top-box .right-search-box .search-input input::-webkit-input-placeholder {
    font-size: 2.67vw;
  }

  .top-box .right-search-box .search-input input::-moz-placeholder {
    font-size: 2.67vw;
  }

  .top-box .right-search-box .search-input input::-ms-input-placeholder {
    font-size: 2.67vw;
  }

  .top-box .right-search-box .search-input input::placeholder {
    font-size: 2.67vw;
  }

  .top-box .right-search-box .search-btn {
    width: 8.8vw;
    height: 7.87vw;

    background-size: 6.67vw 6.27vw;
  }

  .appview {
    height: 100vh !important;
  }
}
</style>
